import { render, staticRenderFns } from "./Campagne.vue?vue&type=template&id=28600435&"
import script from "./Campagne.vue?vue&type=script&lang=js&"
export * from "./Campagne.vue?vue&type=script&lang=js&"
import style0 from "./Campagne.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports